import { Checkbox, CheckboxProps } from 'antd';
import classNames from 'classnames';

interface MCheckboxProps extends CheckboxProps {}

const MCheckbox: React.FC<MCheckboxProps> = (props) => {
  const { className } = props;
  return (
    <Checkbox {...props} className={classNames('trojan-checkbox', className)} />
  );
};

export default MCheckbox;
